export const Role = {
  Admin: 'Administrator',
  GlobalAdmin: 'Global Admin',
  Collaborator: 'Collaborator',
  Designer: 'Designer',
  LightUser: 'Light User'
} as const;

export type Role = (typeof Role)[keyof typeof Role];

export type FeatureFlag =
  'Blogs' | 'Dashboard' | 'NewsLetterSideBar' | 'KnowledgeBase' | 'CaseStudies' | 'DeliverableWorkflows';

export type Settings = {
  organisationName: string | undefined;
  organisationId: string | undefined;
  organisationLogoUrl: string | undefined;
  role: Role | undefined;
  firstName: string | undefined;
  userName: string | undefined;
  userEmail: string | undefined;
  allOrganisations: string[] | undefined;
  allRoles: string[] | undefined;
  canImpersonateUsers: boolean;
  isReadOnlyImpersonation: boolean;
  impersonatedUserId: string | undefined;
  impersonationUsers: { id: string; display: string; role?: string }[];
  isGlobalAdmin: boolean;
  isFirstVisitTime: boolean;
  onboardingExperience: 'none' | 'new' | 'returning' | 'whatsNew';
  onboardingReturnBand: 'recent' | 'moderate' | 'old' | null;
  onboardingDaysAway: number | null;
  onboardingNextRoute: string;
  isPrimaryContact: boolean;
  isStrategyOwner: boolean;
  profilePic: string | undefined;
  allowedModules: string[];
  enabledFeatures: FeatureFlag[];
  allowAddPrimaryFocusAreas: boolean;
  allowAddSecondaryFocusAreas: boolean;
  userUnsubscribeStatus: string | undefined;
  strategyEditRoles: string;
  isSocialFeedEnabled: boolean;
  isAISuggestionEnabled: boolean;
  showStrategyOnboardingVideo: boolean;
};

export const defaultSettings: Settings = {
  organisationName: undefined,
  organisationId: undefined,
  organisationLogoUrl: undefined,
  role: undefined,
  isGlobalAdmin: false,
  isFirstVisitTime: false,
  onboardingExperience: 'none',
  onboardingReturnBand: null,
  onboardingDaysAway: null,
  onboardingNextRoute: '/updates',
  isPrimaryContact: false,
  isStrategyOwner: false,
  firstName: undefined,
  userName: undefined,
  userEmail: undefined,
  allOrganisations: undefined,
  userUnsubscribeStatus: undefined,
  allRoles: undefined,
  canImpersonateUsers: false,
  isReadOnlyImpersonation: false,
  impersonatedUserId: undefined,
  impersonationUsers: [],
  profilePic: undefined,
  allowedModules: [],
  enabledFeatures: [],
  allowAddPrimaryFocusAreas: true,
  allowAddSecondaryFocusAreas: false,
  strategyEditRoles: '',
  isSocialFeedEnabled: false,
  isAISuggestionEnabled: true,
  showStrategyOnboardingVideo: true
};
